export default {
	NAV_HEADER: 'Count Areas',
	LIST_HEADER: 'Areas',
	TIP_TEXT: 'Slide left to delete counting area or slide right to edit',
};
